'use client'

import { memo } from 'react'

import { VaultV2RowList, VaultV2RowListSkeletonRow } from '../../../components/VaultV2RowList'

const VaultRolesLoading = () => {
  return (
    <VaultV2RowList>
      <VaultV2RowListSkeletonRow />
      <VaultV2RowListSkeletonRow />
      <VaultV2RowListSkeletonRow />
    </VaultV2RowList>
  )
}

export default memo(VaultRolesLoading)
